var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex-center flex-grow-1 w-100",
      attrs: { id: "confirm-email" },
    },
    [
      _c(
        "div",
        { staticClass: "text-center w-80" },
        [
          _c("inline-svg", {
            attrs: {
              src: _vm.confirmationReminder,
              height: _vm.imageSize,
              width: _vm.imageSize,
            },
          }),
          _c("h3", {
            staticClass: "registration-headline mb-3 d-block",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.users.onboarding.email_sent_headline")
              ),
            },
          }),
          _vm.articleRegistration
            ? _c("p", {
                staticClass: "text-wrap",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "ui.components.users.onboarding.email_sent_paragraph_gated_html"
                    )
                  ),
                },
              })
            : _c("p", {
                staticClass: "text-wrap",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "ui.components.users.onboarding.email_sent_paragraph_regular_html"
                    )
                  ),
                },
              }),
          _c("ci-button", {
            staticClass: "my-3",
            attrs: {
              id: "return-button",
              variant: "outline-primary",
              label: _vm.backLinkText,
            },
            on: { click: _vm.closeModal },
          }),
          _c("p", { staticClass: "small" }, [
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  _vm.$t("ui.components.users.onboarding.email_not_received")
                ),
              },
            }),
            _c("a", {
              staticClass: "cursor-pointer ml-1",
              attrs: { id: "resend-email" },
              domProps: {
                textContent: _vm._s(
                  _vm.$t("ui.components.users.onboarding.email_resend")
                ),
              },
              on: { click: _vm.resendConfirmationMail },
            }),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }